module.exports = __webpack_public_path__ + "media/images/btn_icon_mypage-ec61de293037aeab52d0628f55ed194b.png";